import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[hideCollapseOnClick]'
})
export class HideCollapseOnClickDirectiveComponent {

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const navbarCollapse = document.querySelector('.navbar-collapse.show') as HTMLElement;

    if (navbarCollapse && target.tagName === 'A') {
      navbarCollapse.classList.remove('show');
    }
  }
}
